import { configureStore } from "@reduxjs/toolkit";

import retriveTenantInformationreducer from "../reducers/no_auth_tenant/retrieve_tenant_information_Slice";
import verifyTenantUserProfileReducer from "../reducers/no_auth_tenant/verify_tenant_user_profile_Slice";
import setMaskedCredentialsReducer from "../reducers/no_auth_tenant/set_masked_credentials_Slice";
import sendTenantUserAccountOtpReducer from "../reducers/no_auth_tenant/send_tenant_user_account_otp_Slice";
import verifyTenantUserAccountOtpReducer from "../reducers/no_auth_tenant/verify_tenant_user_account_otp_Slice";
import verifySalesRepAccountReducer from "../reducers/no_auth_tenant/verify_sales_rep_account_Slice";
import sendSalesRepUserAccountOtpReducer from "../reducers/no_auth_tenant/send_sales_rep_user_account_otp_Slice";

// Store For All Reducers
export const no_auth_tenants_store = configureStore({
 reducer: {
  retrieve_tenant_information: retriveTenantInformationreducer,
  verify_tenant_user_profile: verifyTenantUserProfileReducer,
  set_masked_credentials: setMaskedCredentialsReducer,
  send_tenant_user_account_otp: sendTenantUserAccountOtpReducer,
  verify_tenant_user_account_otp: verifyTenantUserAccountOtpReducer,
  verify_sales_rep_account: verifySalesRepAccountReducer,
  send_sales_rep_user_account_otp: sendSalesRepUserAccountOtpReducer
 }
});